// The brand's marketing content: brands/<BRAND>/site.json and pages/*.json, checked and parsed by
// vite.config.ts with the schemas in shared/src/contentSchema.ts.
import type { ContentPage, FeatureKey } from "@neus/shared";
import content from "virtual:brand-content";
import { features } from "./features";

export const CONTENT = content;

/** Whether content gated by a feature flag shows in this build. */
export const shown = (item: { feature?: FeatureKey }) => !item.feature || features[item.feature];

/** The pages this build serves, besides the not-found page. */
export const PAGES: ContentPage[] = CONTENT.pages.filter((p) => p.path !== "*" && shown(p));

/** Shown for any path the site doesn't have. */
export const NOT_FOUND_PAGE: ContentPage = CONTENT.pages.find((p) => p.path === "*")!;
